/* @flow */
import React from 'react';
import Hit from '../Hit/Hit';
import type {SERPHitShape, ListingShape} from '../Hit/Hit';

type Props = {
    hitData: SERPHitShape,
    listingData: ListingShape,
    isDatelessSearch?: boolean
};

export default function ExpandedSearchGroupHitPlaceholder({
    hitData,
    listingData
}: Props) {
    return (
        <div className={'ExpandedSearchGroupHitPlaceholder'}>
            <div className={'ExpandedSearchGroupPlaceholder__hit'}>
                <Hit hit={hitData} listing={listingData} />
            </div>
            <div className={'ExpandedSearchGroupHitPlaceholder__overlay'} />
        </div>
    );
}
